import {
    CONFIG_LOAD,
    LEAVEBARTER_UPDATE,
} from '../actions/types';
import {
    DEFAULT_CURRENCY_MINOR_UNIT,
    normalizeCurrencyMinorUnit,
} from '../utils/currency';

const INITIAL_STATE = {
    token: null,
    selection: null,
    family: null,
    account: null,
    leaveBarter: null,
    currencyMinorUnit: DEFAULT_CURRENCY_MINOR_UNIT,
    currency: '',
    showBaseCurrency: false,
};

const configReducer = (state = INITIAL_STATE, action) => {
    const {type, payload} = action;
    switch (type) {
        case CONFIG_LOAD:
            return {
                ...payload,
                currencyMinorUnit: normalizeCurrencyMinorUnit(payload?.currencyMinorUnit),
            };
        case LEAVEBARTER_UPDATE:
            return {
                ...state,
                leaveBarter: payload,
            };
        default:
            return state;
    };
};

export default configReducer;
